import { useQuery } from '@tanstack/react-query';
import { getLeaderboard } from '../../../../common/api/scenarios';
import { useParams } from 'react-router-dom'; // Assuming you're using React Router for navigation
import { LeaderboardView } from './leaderboard';
import { Loading } from '../../../../components/Loading';

export default function View() {
  const params = useParams();
  const scenarioUuid = params.scenarioUuid;

  const getQuery = useQuery({
    queryKey: ['scenarios', scenarioUuid, 'leaderboard'],
    queryFn: () => (scenarioUuid ? getLeaderboard(scenarioUuid) : null),
    enabled: true,
    // room membership is always changing, so we don't want to cache it
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
  const leaderboard = getQuery.data;

  if (getQuery.isLoading || !getQuery.data || !leaderboard) {
    // TODO error handling
    return <Loading />;
  }

  return <LeaderboardView leaderboard={leaderboard} />;
}
